module.exports = __webpack_public_path__ + "static/media/dinersClub.55ba266a.svg";